import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Divider,
  Paper,
  Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Icon } from "@iconify/react";



function PrivacyPolicyReport({ data, pageTitle }) {
  const SectionAccordion = ({ title, data, bgColor }) => (
    <Accordion defaultExpanded sx={{ backgroundColor: bgColor }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box elevation={0} sx={{ p: 0 }}>
          {Array.isArray(data) && data.length > 0 ? (
            data.map((item, index) => (
              <Box key={index} elevation={1} sx={{ p: 2, mb: 0, pb: 1 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  {`${item.section}`}
                </Typography>
                <Typography variant="body2"><strong>Quote:</strong> {item.quote}</Typography>
                <Typography variant="body2"><strong>Example:</strong> {item.example}</Typography>
              </Box>
            ))
          ) : (
            <Typography variant="body1">No data available</Typography>
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );

  return (
    <Paper elevation={3} sx={{ padding: 3, width: "100%", maxWidth: 900, margin: '0 auto' }}>
      {(data?.error !== undefined && data?.error !== '') ? <>
        <Box >

          <Typography variant="h4" fontWeight="bold" mb={3} color="rgb(0, 145, 70)" sx={{ textAlign: 'center' }}>
            {pageTitle}
          </Typography>

          <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
            <Typography variant="h6" fontWeight="bold">
              <Icon icon="mdi:web" width={24} height={24} style={{ marginRight: 8 }} />
              Target:
            </Typography>
            <Chip label={data?.current_website_name || data?.current_document_link} color="primary" variant="outlined" sx={{ fontSize: "1rem", padding: "5px" }} />
            
          </Box>
          <Typography variant="body2" mb={0} color="rgb(193,0,0)" sx={{ textAlign: 'center', fontSize: '1.3rem' }}>
              The policy URL could not be processed. Please check the URL and make sure it has the policy text and resubmit.
            </Typography>
        </Box>

      </> : (<Box >

        <Typography variant="h4" fontWeight="bold" mb={3} color="rgb(0, 145, 70)" sx={{ textAlign: 'center' }}>
          {pageTitle}
        </Typography>

        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h6" fontWeight="bold">
            <Icon icon="mdi:web" width={24} height={24} style={{ marginRight: 8 }} />
            Target:
          </Typography>
          <Chip label={data.current_website_name} color="primary" variant="outlined" sx={{ fontSize: "1rem", padding: "5px" }} />
        </Box>

        {/* Title & Website Info */}
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#444" }}>
          <Icon icon="mdi:company" width="24" height="24" style={{ marginRight: 8 }} /> Company: {data.current_company_name}
        </Typography>
        <hr />

        <SectionAccordion title="🚨 Improper Sections" data={data.improper_sections} bgColor="#ffefeb" />
        <SectionAccordion title="⚠️ Missing Sections" data={data.missing_sections} bgColor="#fffde7" />
        <SectionAccordion title="❌ Unnecessary Parts" data={data.unnecessary_part} bgColor="#e3f2fd" />


      </Box>)}
    </Paper>

  );
}

export default PrivacyPolicyReport;
